import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function O2HeaderLogo(props) {
  var children = props.children,
      className = props.className,
      href = props.href,
      src = props.src,
      mobile = props.mobile,
      onClick = props.onClick,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "href", "src", "mobile", "onClick"]);

  var onClickWrapper = function onClickWrapper(e) {
    if (props.disabled) {
      e.preventDefault();
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  var classes = classNames(className, "o2-header__logo");
  var imageClasses = classNames("o2-header__logo-img", {
    "o2-header__logo-img--mobile": mobile
  });
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href || "#"
  }, attributes, {
    className: classes,
    onClick: onClickWrapper
  }), /*#__PURE__*/React.createElement("img", {
    src: src,
    className: imageClasses,
    alt: ""
  }), children && /*#__PURE__*/React.createElement("span", {
    className: "o2-header__logo-text"
  }, children));
}

O2HeaderLogo.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  src: PropTypes.string,
  mobile: PropTypes.bool
};
export default O2HeaderLogo;